import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Avatar,
  Box,
  Button,
  IconButton,
  Snackbar,
  Menu,
  MenuItem,
  Stack,
  Typography,
  CircularProgress,
  Divider,
  useTheme,
  Modal,
} from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import MicOffIcon from "@mui/icons-material/MicOff";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import ScreenShareOutlinedIcon from "@mui/icons-material/ScreenShareOutlined";
import StopScreenShareOutlinedIcon from "@mui/icons-material/StopScreenShareOutlined";
import StreamingChat from "./StreamingChat";
import PanToolIcon from "@mui/icons-material/PanTool";
import PanToolOutlinedIcon from "@mui/icons-material/PanToolOutlined";
import GavelIcon from "@mui/icons-material/Gavel";

import LockIcon from "@mui/icons-material/Lock";

import { SocketContext } from "../../context/socket";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  copyToClipboard,
  generateDynamicLink,
  fullName,
  getUserDetail,
  isOwnerId,
  onShare,
  putRecors,
} from "../../constants/function";
import { Images } from "../../assets/common";
import OutsideClickHandler from "react-outside-click-handler";
import CircleIcon from "@mui/icons-material/Circle";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import notifier from "../Notifier";
import HttpService from "../../services/http-service";
import ApiService from "../../services/api-service";
import AWS from "aws-sdk";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { S3_BUCKET } from "../../constants/api";
import IosShareIcon from "@mui/icons-material/IosShare";
import ProfileMenu from "../ProfileMenu";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import VolumeOffRoundedIcon from "@mui/icons-material/VolumeOffRounded";
import { useTranslation } from "react-i18next";
import SongList from "./songList";
import MusicNoteAnimation from "./MusicNoteAnimation";
import { useSelector } from "react-redux";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import emitter from '../../EventEmitter';
import { getSubscriptions } from "../../pages/Subscription"; // Correctly import the named export
import ConfirmPopup from "../ConfirmPopup";
import Loader from "../../components/Loader";
import Subuserben from "../Subuserben";
import LivestreamPayPopup from "../LivestreamPayPopup";






export default function StreamingControls({
  isMute,
  video,
  mute,
  disableVideo,
  userId,
  isVideo,
  shareScreen,
  artistId,
  videoCall,
  playlistId,
  isOwner,
  tokenData,
  liveUser,
  stopShare,
  role,
  isJoined,
  raisedList,
  hostMuted,
  streamData,
  switchAudio,
  mics,
  currentMic,
  handleFile,
  handleStopSong,
  play,
  liveUsers,
  cameras,
  currentCamera,
  switchVideo,
  userStream,
  obs,
  getUserDetail,

}) {
  // const [songData, setSongData] = React.useState({});
  const { count } = useSelector((state) => state.adv);
  const [volume, setVolume] = React.useState(0);
  const [audienceStream, setAudienceStream] = React.useState(null);
  const [openMusic, setOpenMusic] = React.useState();
  const { t } = useTranslation("common");
  const [playlistDetails, setPlaylistDetails] = useState(null);
  const [option, setOption] = React.useState(false);
  const [started, setStarded] = React.useState(false);
  const [record, setRecord] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const openSetting = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const socket = useContext(SocketContext).Socket;
  const [raised, setRaised] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [copied, setCopied] = React.useState(null);
  const [newRaised, setNewRaise] = React.useState(false);
  const [starting, setStarting] = React.useState(false);
  const [isflip, setIsFlip] = React.useState(false);
  const [dynamicLink, setDynamicLink] = React.useState(null);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loadingSubscription, setLoadingSubscription] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const theme = useTheme();
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [userDetails, setUserDetails] = useState(null);
  

  const [showBenefitsPopup, setShowBenefitsPopup] = useState(false);

  const [openPayModel, setOpenPayModel] = React.useState(false);

  const [newWindow, setNewWindow] = React.useState();
  const handleOpenListings = () => setShowListings(true);
  const handleCloseListings = () => setShowListings(false);

    const handlePaymentSubmit = (amount, paymentType) => {

    };



 // Fetch the subscription status
const fetchSubscriptionStatus = async () => {
  if (!artistId) return; // Ensure artistId is available

  try {
    setLoadingSubscription(true);
    const response = await ApiService.USER_DETAILS(artistId); // Fetch user details based on artistId

    if (response?.result) {

      const isUserSubscribed = response.result.isSubscribed || false;

      setIsSubscribed(isUserSubscribed); // Set subscription status
      setUserData(response.result); // Update userData with fetched details
    }
    setLoadingSubscription(false);
  } catch (error) {
    setLoadingSubscription(false);
  }
};

// Fetch subscription status when artistId changes
useEffect(() => {
  if (artistId) {
    fetchSubscriptionStatus();
  }
}, [artistId]);

    const handleSubscribe = async (artistId) => {
      try {
        setLoading(true);

        const response = await ApiService.SUBSCRIBE_ARTIST({
          artistId,
          currency: "siki",
        });


        if (response.status === "success") {
          setUserData((prev) => ({
            ...prev,
            isSubscribed: true,
            subscribedStatus: "Active",
            subscriptionStatus: "enabled",
          }));
          setIsSubscribed(true);
        } else if (response.status === "insufficient_balance") {
          // Handle the insufficient balance scenario
          setOpenPayModel(true); // Show the LivestreamPayPopup to buy more balance
        }

        setLoading(false);
        setShowConfirm(false);
      } catch (error) {
        setLoading(false);
        setShowConfirm(false);
        if (error.response?.status === 400) {
          setOpenPayModel(true); // Show the LivestreamPayPopup if it's an insufficient balance issue
        }
      }
    };
const handleUnsubscribe = async () => {
  try {
    setLoadingSubscription(true);

    const response = await ApiService.UNSUBSCRIBE_ARTIST({
      artistId,
      currency: "siki",
    });


    // Check if the response indicates success
    if (response?.status === "success") {
      // Update the isSubscribed state and userData
      setIsSubscribed(false);
      setUserData((prev) => ({
        ...prev,
        isSubscribed: false, // Make sure the isSubscribed field is updated
      }));
    } else {
    }

    setLoadingSubscription(false);
  } catch (error) {
    setLoadingSubscription(false);
  }
};

const getPaypalLink = async (amount) => {
  if (amount >= 4.99 && amount <= 20000) {
    try {
      setLoading(true);
      const response = await ApiService.PAYPALLINK({
        amount: amount,
      });
      setLoading(false);
      setNewWindow(response.result.links[1].href);
      popupClosed();
    } catch (error) {
      setLoading(false);
      console.error("Error getting PayPal link:", error);
    }
  }
};

const getMoonpayLink = async (amount) => {
  if (amount >= 30 && amount <= 20000) {
    try {
      setLoading(true);
      const response = await ApiService.FUNDINGLINK({
        amount: parseInt(amount),
        tag: "time to buy some BTC",
        currency: currency,
      });
      setLoading(false);
      setFundLink(response["result"]);
      popupClosed();
    } catch (error) {
      setLoading(false);
      console.error("Error getting Moonpay link:", error);
    }
  }
};


  // Open new window when `newWindow` URL is set
  useEffect(() => {
    if (newWindow) {
      const win = window.open(
        newWindow,
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
      );
      
      // Check if window was blocked by the browser
      if (!win || win.closed || typeof win.closed == 'undefined') { 
        alert("Please enable pop-ups for this website to complete the payment.");
      }
    }
  }, [newWindow]);

  // Handle closing the payment popup
  const popupClosed = () => {
    setOpenPayModel(false);
  };


  
  
  



  const getDynamicLink = async () => {
    if (!!dynamicLink) {
      return dynamicLink;
    }

    const thumbnail = playlistDetails?.GIF?.filePath;
    const link = await generateDynamicLink('livestream', playlistId, playlistDetails.title, '', thumbnail);
    setDynamicLink(link);

    return link;
  }

  const handleCopy = async (action) => {
    const url = await getDynamicLink();

    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, url, {
          id: user._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: playlistId,
          sharedBy: fullName(user),
          eventValue: ["Livestream"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: user._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: playlistId,
          sharedBy: fullName(user),
          eventValue: ["Livestream"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (socket) {
      socket.on("raised", function (data) {
        if (isOwner && data.channelName === playlistId && data.raised) {
          setNewRaise(true);
        }
      });
      socket.on("recording-started", function (data) {
        console.log("recording-started", data);
        if (
          isOwner &&
          data.channelName === playlistId &&
          data.recordingStarted
        ) {
          setStarded(true);
          setStarting(false);
        }
      });
      socket.on("recording-stopped", function (data) {
        if (
          isOwner &&
          data.channelName === playlistId &&
          !data.recordingStopped
        ) {
          setStarded(false);
          setStarting(false);
        } else if (
          isOwner &&
          data.channelName === playlistId &&
          data.recordingStopped &&
          data.recordingUrl
        ) {
          setStarded(false);
          setStarting(false);
          // download(data.recordingKey);
        }
      });
      // socket.on("song-started", (data) => {
      //   if (data.roomId === playlistId) setSongData({ ...data });
      // });
    }
  }, [socket]);

  // TODO: SK-420
  const download = async (url) => {
    try {
      var s3 = new AWS.S3();

      s3.getObject(
        {
          Bucket: S3_BUCKET,
          Key: url,
        },
        function (error, data) {
          if (error != null) {
            console.log("Failed to retrieve an object: " + error);
          } else {
            let blob = new Blob([data.Body], { type: data.ContentType });
            let urlCreator = window.URL || window.webkitURL;
            let videoUrl = urlCreator.createObjectURL(blob);
            let tag = document.createElement("a");
            tag.href = videoUrl;
            tag.target = "_blank";
            tag.download = "recording.mp4";
            document.body.appendChild(tag);
            tag.click();
            document.body.removeChild(tag);
          }
        }
      );
    } catch (error) { }
  };

  function handleHandleraise() {
    socket.emit("raise", {
      raised: !raised,
      user: {
        userId: user._id,
        firstName: user.firstName,
        lastName: user.lastName,
        profileImg: user?.profileImg,
      },
      channelName: playlistId,
    });
    setRaised(!raised);
  }
  useEffect(() => {
    if (raisedList.length === 0) setOpen(false);
  }, [raisedList]);

  const handlleRecord = () => {
    if (socket) {
      if (!record) {
        socket.emit("start-recording", {
          channelName: playlistId,
          height: 1080,
          width: 1920,
        });
        setStarting(true);
      } else {
        setStarting(true);
        socket.emit("stop-recording", {
          channelName: playlistId,
        });
        setStarting(true);
      }
      setRecord(!record);
    }
  };
  const doNothing = () => { };
  const handleClickShare = async (event) => {
    setOption(!option);

    const url = await getDynamicLink();

    putRecors({
      id: user._id,
      referralLink: url,
      eventType: ["click"],
      eventAsset: playlistId,
      sharedBy: fullName(user),
      eventValue: ["Livestream"],
      socialMedia: null,
    });
  };
  const handleCloseShare = () => {
    setOption(false);
  };

  useEffect(() => {
    if (!playlistDetails) getPlaylist();
  }, [playlistDetails]);

  const getPlaylist = async () => {
    const response = await ApiService.PLAYLIST_DETAIL({
      _id: playlistId,
      pageNo: 1,
      pageSize: 1,
    });
    setPlaylistDetails(response?.result);
  };

  function onFileChooser(id) {
    document.getElementById(id).click();
  }
  const handleVolume = () => {
    if (userStream) {
      if (userStream?.audioTrack?._volume > 0 && count)
        userStream.audioTrack.setVolume(0);
      else if (userStream?.audioTrack?._volume === 0 && !count)
        userStream.audioTrack.setVolume(100);
      // setVolume(audienceStream.audioTrack._volume);
    }
  };
  useEffect(() => {
    setAudienceStream(userStream);
    if (count && userStream) handleVolume();
  }, [userStream]);

  useEffect(() => {
    if (!isOwner) handleVolume();
  }, [count]);

  const handleChange = (event) => {
    setIsFlip(event.target.checked);
  };

  const handleFlip = (event) => {
    if (socket) {
      // if (!isflip) {
      socket.emit("video-flip", {
        channelName: playlistId,
        isflip: !isflip, // Flip the value of isflip
      });
      setIsFlip(!isflip); // Flip the value of isflip in the state
      // }
    }
  };

  return (
    <Box
      id="_streaming_control"
      className="_streaming_control"
    // sx={{
    //   width:
    //     isOwner && liveUser > 0
    //       ? "85%"
    //       : isOwner && liveUser === 0
    //       ? "99%"
    //       : "99% !important",
    //   transition: "width 0.2s ease-in-out 0s",
    // }}
    >
      {/* Streaming chat */}
      {/* <Stack> */}
      {tokenData?.token ? (
        <StreamingChat
          streamData={streamData}
          isOwner={isOwner}
          playlistId={playlistId}


        />
      ) : null}
      {/* <StreamPlayer
        handleFile={(song, songs, index, prevIndex, restart) =>
          handleFile(song, songs, index, prevIndex, restart)
        }
      /> */}

      {isOwner ? (
        <Stack
          className="ml_auto streaming_control_box"
          direction="row"
          // spacing={1}
          alignItems="center"
        >
 
          {raisedList.length > 0 ? (
            <OutsideClickHandler
              onOutsideClick={() => {
                setOpen(false);
              }}
            >
              <Button
                sx={{ height: "30px !important", position: "relative" }}
                onClick={() => {
                  setOpen(!open);
                  setNewRaise(false);
                }}
                variant="outlined"
                color="primary"
                startIcon={
                  <PanToolIcon sx={{ fontSize: "13px" }} color="primary" />
                }
                endIcon={
                  newRaised ? <CircleIcon className="_new_raised_dot" /> : null
                }
              >
                list
              </Button>
            </OutsideClickHandler>
          ) : null}
          {isJoined || obs ? (
            <IconButton className="btn" onClick={() => setOpenMusic(true)}>
              <img src={Images.allMusic} className="icon" alt="songs" />
            </IconButton>
          ) : null}

          {obs ? (
            <Tooltip title="Flip the screen" arrow placement="top">
              <Switch
                checked={isflip}
                onChange={handleChange}
                onClick={handleFlip}
                inputProps={{ "aria-label": "controlled" }}
              />
            </Tooltip>
          ) : null}

          {!obs ? (
            starting ? (
              <IconButton className="btn">
                <CircularProgress
                  sx={{
                    width: "30px !important",
                    height: "initial !important",
                  }}
                  color="primary"
                />
              </IconButton>
            ) : (
              <IconButton
                onClick={handlleRecord}
                className="btn"
                disabled={starting}
                title={record ? t("stream.tooltip4") : t("stream.tooltip5")}
              >
                <RadioButtonCheckedIcon
                  sx={{
                    color: record ? "#E3293E" : "#ffffff",
                    fontSize: "18px",
                  }}
                />
              </IconButton>
            )
          ) : null}

          <Box sx={{ position: "relative" }}>
            <IconButton className="btn" onClick={handleClickShare}>
              <IosShareIcon className="icon" />
            </IconButton>
            {option ? (
              <OutsideClickHandler
                onOutsideClick={() => {
                  handleCloseShare();
                }}
              >
                <ProfileMenu
                  right={"0px"}
                  isHeader={true}
                  isLast={"-120px !important"}
                  actions={[
                    { key: "m14", action: t("dropMenu.m14") },
                    { key: "m15", action: t("dropMenu.m15") },
                    { key: "m16", action: t("dropMenu.m16") },
                    // "Share on Instagram",
                  ]}
                  handleProfileMenuChoice={(action) => (
                    handleCopy(action), handleCloseShare()
                  )}
                />
              </OutsideClickHandler>
            ) : null}
          </Box>
          {!obs ? (
            <IconButton
              id="_share_screen_btn"
              className="btn"
              onClick={() => (isVideo ? shareScreen() : stopShare())}
              title={isVideo ? t("stream.tooltip6") : t("stream.tooltip7")}
            >
              {isVideo ? (
                <ScreenShareOutlinedIcon className="icon" />
              ) : (
                <StopScreenShareOutlinedIcon className="icon" />
              )}
            </IconButton>
          ) : null}

          {isJoined ? (
            <IconButton
              title={video ? t("stream.tooltip8") : t("stream.tooltip9")}
              onClick={disableVideo}
              className="btn"
              disabled={video === null}
            >
              {!video ? (
                <VideocamOffIcon className="icon" />
              ) : (
                <VideocamIcon className="icon" />
              )}
            </IconButton>
          ) : null}

          {isJoined ? (
            <IconButton
              title={isMute ? t("stream.tooltip10") : t("stream.tooltip11")}
              onClick={mute}
              className="btn"
            >
              {isMute ? (
                <MicOffIcon className="icon" />
              ) : (
                <MicIcon className="icon" />
              )}
            </IconButton>
          ) : null}
          {isJoined && mics.length > 0 ? (
            <Stack>
              <IconButton
                className="btn"
                onClick={handleClick}
                title={t("stream.tooltip12")}
              >
                <SettingsOutlinedIcon className="_cp icon" color="default" />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openSetting}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                // transformOrigin={{
                //   vertical: "top",
                //   horizontal: "left",
                // }}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                {mics.map((mic, index) => (
                  <MenuItem
                    key={index}
                    selected={mic.label === currentMic.label}
                    onClick={() => {
                      handleClose();
                      switchAudio(mic.label);
                    }}
                  >
                    {mic.label}
                  </MenuItem>
                ))}
                <Divider sx={{ my: 0.5 }} />
                {cameras.map((camera, index) => (
                  <MenuItem
                    key={index}
                    selected={camera.label === currentCamera.label}
                    onClick={() => {
                      handleClose();
                      switchVideo(camera.label);
                    }}
                  >
                    {camera.label}
                  </MenuItem>
                ))}
              </Menu>
            </Stack>
          ) : null}
        </Stack>
      ) : null}

      {!isOwner ? (
        <Stack
          className="streaming_control_box_audience"
          alignItems="center"
          direction="row"
          spacing={1}
          sx={{ position: "fixed", right: "11%", bottom: "0px" }}
        >
          {/* {songData?.song ? <MusicNoteAnimation song={songData} /> : null} */}
          {/*TODO: Host audio volume setting for audience */}
          {/* <IconButton onClick={() => handleVolume()}>
            {volume > 0 ? (
              <VolumeUpRoundedIcon sx={{ fontSize: "22px" }} color="default" />
            ) : (
              <VolumeOffRoundedIcon sx={{ fontSize: "22px" }} color="default" />
            )}
          </IconButton> */}

          {role === "host" && isJoined ? (
            <IconButton
              title={video ? t("stream.tooltip8") : t("stream.tooltip9")}
              onClick={disableVideo}
              className="btn"
              disabled={video === null}
            >
              {!video ? (
                <VideocamOffIcon className="icon" />
              ) : (
                <VideocamIcon className="icon" />
              )}
            </IconButton>
          ) : null}



        <Button
          variant={isSubscribed ? "contained" : "outlined"}
          color={isSubscribed ? "error" : "primary"}
          onClick={() => {
            if (isSubscribed) {
              setShowBenefitsPopup(true); // Show the custom popup
            } else {
              setShowConfirm(true); // Show confirm popup before subscribing
            }
          }}
          disabled={loadingSubscription || loading}
          sx={
            isSubscribed
              ? {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  padding: 0,
                  minWidth: 'unset',
                  '&:hover': {
                    backgroundColor: "transparent",
                  },
                }
              : {}
          }
        >
          {loadingSubscription ? (
            "Loading..."
          ) : isSubscribed ? (
            <img 
              src={Images.SubLive}
              alt="Benefits"
              style={{ width: '20px', height: '20px' }}
            />
          ) : (
            "Subscribe"
          )}
        </Button>

        {openPayModel && (
      <LivestreamPayPopup
        open={openPayModel}
        handleClose={popupClosed}
        handleSubmit={(amount, type) => {
          if (type == "moonPay") {
            getMoonpayLink(amount);
          } else {
            getPaypalLink(amount);
          }
        }}
        loading={loading}
      />
        )}

        {showBenefitsPopup && (
          <Subuserben 
            open={showBenefitsPopup} // Pass the 'open' prop
            onClose={() => setShowBenefitsPopup(false)} 
            title="Subscription Benefits" 
            content="Here are the exclusive benefits you get as a subscriber!" 
          />
        )}



        <ConfirmPopup
          open={showConfirm}
          id={userData["_id"]}
          index={0}
          message={
            <>
              <div style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px", color: "#ffee20" }}>
                {`Subscribe to ${userData["firstName"] || "this artist"}?`}
              </div>
              <div style={{ marginBottom: "8px" }}>
                <span style={{ fontWeight: "500", color: "#ffee20" }}>Fee:</span> {userData["subscriptionFee"]} SIKI
              </div>
              <div style={{ marginBottom: "12px" }}>
                <span style={{ fontWeight: "500", color: "#ffee20" }}>Approx.:</span> {userData["subscriptionFee"] * 0.05} USD
              </div>
              <hr style={{ border: "none", borderTop: "1px solid #e0e0e0", margin: "12px 0" }} />
              <div style={{ marginTop: "10px", fontSize: "16px", fontWeight: "600", color: "#ffee20" }}>
                Subscriber Benefits:
              </div>
              <ul style={{ paddingLeft: "0", margin: "8px 0", listStyleType: "none" }}>
                <li style={{ marginBottom: "6px", display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px" }}>🎵</span> Pre-release music to subscribers only
                </li>
                <li style={{ marginBottom: "6px", display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px" }}>🔒</span> Private livestreams for subscribers only
                </li>
                <li style={{ marginBottom: "6px", display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px" }}>🏅</span> Special badge for subscribers only
                </li>
                <li style={{ marginBottom: "6px", display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px" }}>📺</span> VOD livestreams for subscribers only
                </li>
              </ul>
            </>
          }
          handleClose={(confirmed) => {
            if (confirmed) {
              handleSubscribe(artistId);
            }
            setShowConfirm(false);
          }}
        />



          <Box sx={{ position: "relative" }}>
            <IconButton
              className="btn"
              sx={{ width: "30px", height: "30px", backgroundColor: "#353535" }}
              onClick={handleClickShare}
            >
              <IosShareIcon sx={{ fontSize: "18px" }} className="icon" />
            </IconButton>
            {option ? (
              <OutsideClickHandler
                onOutsideClick={() => {
                  handleCloseShare();
                }}
              >
                <ProfileMenu
                  right={"0px"}
                  isHeader={true}
                  isLast={"-120px !important"}
                  actions={[
                    { key: "m14", action: t("dropMenu.m14") },
                    {
                      key: "m15",
                      action: t("dropMenu.m15"),
                    },
                    {
                      key: "m16",
                      action: t("dropMenu.m16"),
                    },
                    // "Share on Instagram",
                    ,
                  ]}
                  handleProfileMenuChoice={(action) => (
                    handleCopy(action), handleCloseShare()
                  )}
                />
              </OutsideClickHandler>
            ) : null}
          </Box>
          {role === "host" ? (
            <IconButton
              sx={{ cursor: hostMuted ? "not-allowed" : "pointer" }}
              title={
                hostMuted
                  ? t("stream.tooltip15")
                  : isMute
                    ? t("stream.tooltip10")
                    : t("stream.tooltip11")
              }
              onClick={() => (hostMuted ? doNothing() : mute())}
              className="btn"
            >
              {isMute ? (
                <MicOffIcon
                  sx={{
                    color: hostMuted ? "grey !important" : "#ffffff !important",
                  }}
                  className="icon"
                />
              ) : (
                <MicIcon className="icon" />
              )}
            </IconButton>
          ) : null}
          <IconButton onClick={handleHandleraise}>
            {raised ? (
              <PanToolIcon sx={{ fontSize: "16px" }} />
            ) : (
              <PanToolOutlinedIcon sx={{ fontSize: "16px" }} />
            )}
          </IconButton>
        </Stack>
      ) : null}
      {open ? (
        <Stack className="_raised_list" sx={{ position: "absolute" }}>
          {raisedList &&
            raisedList.map((raised, index) => (
              <Stack
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{ padding: "5px 10px" }}
              >
                {raised?.user?.userId ? (
                  <Avatar
                    sx={{ width: 28, height: 28 }}
                    src={
                      raised?.user?.profileImg?.filePath ||
                      raised?.user?.profileImg ||
                      Images.default_user
                    }
                    alt={raised?.user?.firstName}
                  />
                ) : null}

                <Typography className="fs-14">
                  {fullName(raised?.user)}
                </Typography>
              </Stack>
            ))}
        </Stack>
      ) : null}
      {/* {started ? (
        <Snackbar
          sx={{ backgroundColor: "green", color: "black" }}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "botton", horizontal: "center" }}
          open={started}
          onClose={() => setStarded(false)}
          message={record ? t("recordingStart") : t("recoringStopped")}
        />
      ) : null} */}
      {openMusic ? (
        <SongList
          open={openMusic}
          liveUsers={liveUsers}
          roomId={playlistId}
          handleClose={(
            song,
            songs,
            index,
            prevIndex,
            restart,
            volume,
            preSong
          ) =>
            typeof index === "number"
              ? handleFile(
                song,
                songs,
                index,
                prevIndex,
                restart,
                volume,
                preSong
              )
              : setOpenMusic(false)
          }
        />
      ) : null}
    </Box>
  );
}
